import PageSEO from '@/components/base/PageSEO';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategoriesBento from './components/CategoriesBento';
import FeaturesSection from './components/FeaturesSection';
import ProductGallery from './components/ProductGallery';
import DarkCTASection from './components/DarkCTASection';
import ArticleSection from './components/ArticleSection';
import CTABanner from './components/CTABanner';
import Footer from './components/Footer';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://cssbuyspreadsheet.wtf';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'CSSBuy Spreadsheet',
    url: SITE_URL,
    description: 'Planilha CSSBuy atualizada diariamente com os melhores produtos para importar da China. Sneakers, streetwear, acessórios e mais com preços verificados e análise de risco.',
    inLanguage: 'pt-BR',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_URL}/?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'CSSBuy Spreadsheet',
    url: SITE_URL,
    description: 'Hub definitivo de descoberta de produtos para importação da China. Planilha atualizada diariamente com sneakers, streetwear, acessórios e muito mais.',
    sameAs: [
      'https://kaspreadsheet.com/',
    ],
  },
];

export default function Home() {
  return (
    <main>
      <PageSEO
        title="CSSBuy Spreadsheet 2026 — Planilha Atualizada de Produtos | Guia de Importação"
        description="CSSBuy Spreadsheet 2026: planilha atualizada diariamente com os melhores produtos para importar da China. Descubra sneakers, streetwear, acessórios e mais com preços verificados e análise de risco. Acesse agora o hub definitivo de compras internacionais."
        canonicalPath="/"
        keywords="cssbuy spreadsheet, planilha cssbuy, importar da china, agentes de compras china, cssbuy 2026, sneakers china, streetwear china, cssbuy guia, produtos china baratos, planilha produtos importados"
        jsonLd={homeJsonLd}
      />
      <Navbar />
      <HeroSection />
      <CategoriesBento />
      <FeaturesSection />
      <ProductGallery />
      <DarkCTASection />
      <ArticleSection />
      <CTABanner />
      <Footer />
    </main>
  );
}